import { Card, Row, Col, Image, Spin, Modal, message, Button, Table } from "antd";
import logo from "../../assets/images/NewLogoCW.svg";
import red from "../../assets/images/red.svg";
import green from "../../assets/images/green.svg";
import posImg from "../../assets/images/posImg.svg";
import db from "../../database";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { timeStamp } from "../../utility/timestamp";
import { useEffect, useState } from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { getOAuthHeaders } from "../../constants/oAuthValidation";
import { useHistory } from "react-router-dom";
import { getTills, posConfigService, syncTillData, upsertPOSActivity } from "../../services";
import { useTranslation } from "react-i18next";
import { getMultilingualText } from "../../utility/getMultilingualText ";
import laptop3 from "../../assets/images/laptop3.svg";
import Scrollbars from "react-custom-scrollbars";
import { getStoreOps, upsertStoreOps, tillRegistration } from "../../services";
import SyncSide from "../../assets/images/sideFullSync.svg";
import messages from "../../errors/messages.en-IN.json";
import PostCloseSalesModal from "./PostCloseSalesModal";

const Till = () => {
  const { t } = useTranslation();
  const multilingual = process.env.REACT_APP_MULTILINGUAL === "true" && localStorage.getItem("selectedLanguage") !== "English";
  const redirectUrl = process.env.REACT_APP_redirectURL;
  const [runEffect, setRunEffect] = useState(true);
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tills, setTills] = useState();
  const [tillValue, setTillValue] = useState(JSON.parse(localStorage.getItem("tillValue")));
  const [errorModalVisible, setErrorModalVisible] = useState(false);
  const [errorProducts, setErrorProducts] = useState([]);
  const [postCloseModalVisible, setPostCloseModalVisible] = useState(false);
  const [postCloseData, setPostCloseData] = useState({
    storeClosedDate: "",
    newBusinessDate: "",
    closedTime: "",
    tillId: "",
    cashierName: "",
  });
  const islocked = localStorage.getItem("locked");
  let email = "";
  let Enterprise = "";
  let username;
  let cleanToken;
  const authHeaders = getOAuthHeaders();
  if (authHeaders && authHeaders.access_token && (authHeaders.email || authHeaders.username)) {
    email = authHeaders.email;
    Enterprise = authHeaders.Enterprise;
    cleanToken = authHeaders.access_token;
    username = authHeaders.username;
  } else {
    history.push("/sign-in");
  }

  const handleStoreOpsService = async (bunitId) => {
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    const tillData = JSON.parse(localStorage.getItem("tillData"));
    const dayEndPreferences = JSON.parse(tillData?.dayEndPreferences);
    if (posConfig?.disableOfflineBilling === "Y" && dayEndPreferences[0]?.postCloseSalesDate === "NXT") {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      if (tillEvents.length > 0) {
        const currentDate = moment().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else {
          const posConfig = JSON.parse(localStorage.getItem("posConfig"));
          if (posConfig?.shiftClose) {
            history.push("/close-till");
          } else {
            history.push("/");
          }
          return { redirected: true };
        }
      } else {
        const response = await getStoreOps(bunitId);
        if (response?.status === 200) {
          const storeOpsData = response?.data?.data?.getStoreOps;
          if (storeOpsData?.status === "OP") {
            return response;
          } else if (storeOpsData?.status === "CL") {
            const tillData = JSON.parse(localStorage.getItem("tillData"));
            const tillValue = JSON.parse(localStorage.getItem("tillValue"));

            // Calculate dates
            const closedDate = moment(storeOpsData?.businessDate || new Date()).format("DD/MM/YYYY");
            const nextBusinessDate = moment(storeOpsData?.businessDate || new Date())
              .add(1, "days")
              .format("DD/MM/YYYY");
            const closedTime = storeOpsData?.closedTime || "8:00 PM";

            setPostCloseData({
              storeClosedDate: closedDate,
              newBusinessDate: nextBusinessDate,
              closedTime: closedTime,
              tillId: tillValue?.name || tillData?.tillAccess?.cwrTill?.till || "N/A",
              cashierName: username || "N/A",
            });
            setPostCloseModalVisible(true);
            setLoading(false);
            return { redirected: true };
          } else if (!storeOpsData) {
            return response;
          }
        }
      }
    } else {
      const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();
      if (tillEvents.length > 0) {
        const currentDate = moment().format("YYYY-MM-DD");
        const tillEventDate = tillEvents[0]?.openingTime?.split(" ")[0];
        if (currentDate === tillEventDate) {
          return await getStoreOps(bunitId);
        } else {
          // const posConfig = JSON.parse(localStorage.getItem("posConfig"));
          // if (posConfig?.shiftClose) {
          //   history.push("/close-till");
          // } else {
          //   history.push("/");
          // }
          return { redirected: true };
        }
      } else {
        return await getStoreOps(bunitId);
      }
    }
  };

  // Add handlers for the modal buttons
  const handlePostCloseContinue = async () => {
    setPostCloseModalVisible(false);
    setLoading(true);

    const tillEvents = await db?.tillEvents.where("tillStatus").equals("open").toArray();

    if (tillEvents.length > 0) {
      const tillSessionId = tillEvents[0]?.tillSessionId; // 🔹 rename event → currentEvent

      await db.ordersData
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((order) => {
          order.tillStatus = "closed";
        });

      await db.paymentsData
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((payment) => {
          payment.tillStatus = "closed";
        });

      await db.tillEvents
        .where("tillSessionId")
        .equals(tillSessionId)
        .modify((tillEvent) => {
          tillEvent.tillStatus = "closed";
          tillEvent.isSynced = 1;
          tillEvent.user = JSON.parse(localStorage.getItem("userData"))?.user;
        });
    }

    const userData = JSON.parse(localStorage.getItem("userData")) ? JSON.parse(localStorage.getItem("userData")) : {};
    const userid = userData?.user_id;
    const nextBusinessDate = moment().add(1, "day").format("YYYY-MM-DD HH:mm:ss");
    const response = await getStoreOps(tillValue?.cSBunitID, nextBusinessDate);
    if (response?.status === 200) {
      const storeOpsData = response?.data?.data?.getStoreOps;
      if (storeOpsData?.status === "OP") {
        localStorage.setItem("nextBusinessDate", nextBusinessDate);
        setTillValue({});
        history.push("/login");
      } else if (storeOpsData?.status === "CL" || storeOpsData === null) {
        const resStoreOps = await upsertStoreOps(tillValue?.cSBunitID, userid, nextBusinessDate);
        const upsertData = resStoreOps?.data?.data?.upsertStoreOps;

        if (upsertData?.status === "200") {
          localStorage.setItem("nextBusinessDate", nextBusinessDate);
          setTillValue({});
          history.push("/login");
        } else {
          message.error(upsertData?.message);
          setLoading(false);
        }
      }
    }
  };

  const handlePostCloseCancel = () => {
    setPostCloseModalVisible(false);
    // Logout logic
    onUserModal();
  };

  const parseRemarksProducts = (remarks) => {
    try {
      const match = remarks.match(/Result:\s*(\[.*\])/);
      if (match && match[1]) {
        let arrStr = match[1];

        // ✅ Quote keys (m_product_id → "m_product_id")
        arrStr = arrStr.replace(/(\w+):/g, '"$1":');

        // ✅ Quote string values that are not already quoted/null
        arrStr = arrStr.replace(/:"([^",\]\}]*)"(?![,\]\}])/g, (m, p1) => {
          // already quoted string, leave it
          return m;
        });
        arrStr = arrStr.replace(/:"?([^",\]\}]+)"?(?=[,\]\}])/g, (m, p1) => {
          if (p1 === "null") return ":null"; // keep null
          return `:"${p1.trim()}"`;
        });

        return JSON.parse(arrStr);
      }
    } catch (err) {
      console.error("Error parsing remarks:", err, remarks);
    }
    return [];
  };

  useEffect(async () => {
    const tillRegistrations = await db.tillRegistrations.toArray();
    const posConfigData = JSON.parse(localStorage.getItem("posConfigData"));
    const posConfig = JSON.parse(localStorage.getItem("posConfig"));
    if (runEffect) {
      setRunEffect(!runEffect);
      const nameTill = tillValue?.name;
      if (tillValue && (username || email) && cleanToken && tillRegistrations.length > 0) {
        setLoading(true);
        const userData = Enterprise ? username : email;
        await syncTillData(userData, authHeaders);
        let tillData = JSON.parse(localStorage.getItem("tillData")) || "";
        if (tillData !== null && tillData !== undefined) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) return;
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            if (islocked) {
              tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
              localStorage.setItem("username", username);
              tillData.time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
              localStorage.setItem("tillData", JSON.stringify(tillData));
              // localStorage.setItem("documentSequence", tillData?.tillAccess?.cwrTill?.nextAssignedNumber);
              localStorage.removeItem("locked");
              setTillValue({});
              if (posConfigData?.posType === "PRD") {
                history.push("/production");
              } else if (posConfig?.enableEstimate === "Y") {
                history.push("/estimate");
              } else {
                history.push("/pos");
              }
            } else if (posConfigData?.posType === "PRD") {
              setTillValue({});
              history.push(`/login`);
            } else {
              const handleStoreOps = async () => {
                try {
                  tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
                  tillData.time = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
                  localStorage.setItem("tillData", JSON.stringify(tillData));
                  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
                  const matchedRep = salesReps.find((rep) => rep.name === username);
                  if (matchedRep) {
                    history.push(`/login`);
                  } else {
                    const result = await handleStoreOpsService(tillValue?.cSBunitID);
                    if (result?.redirected) return;
                    const storeOpsData = result?.data?.data?.getStoreOps;
                    if (result?.data?.data?.getStoreOps?.status === "ERR") {
                      setLoading(false);
                      const remarks = result?.data?.data?.getStoreOps?.remarks;
                      const products = parseRemarksProducts(remarks);
                      if (products.length > 0) {
                        setErrorProducts(products);
                        setErrorModalVisible(true);
                      } else {
                        message.error(remarks || `${messages.errors.system.unexpected_error}`);
                      }
                      return;
                    } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
                      message.error(result?.data?.data?.getStoreOps?.remarks);
                    }
                    if (!storeOpsData) {
                      const resStoreOps = await upsertStoreOps(tillValue?.cSBunitID, tillData.tillAccess.csUserId);
                      const upsertData = resStoreOps?.data?.data?.upsertStoreOps;
                      if (upsertData?.status === "200") {
                        setTillValue({});
                        history.push(`/login`);
                      } else {
                        message.error(upsertData?.message);
                        setLoading(false);
                      }
                    } else if (storeOpsData.status === "OP") {
                      setTillValue({});
                      history.push(`/login`);
                    } else {
                      setTillValue({});
                      setLoading(false);
                      Modal.confirm({
                        title: `This till has been closed "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
                        icon: null,
                        cancelText: "",
                        okText: "Okay",
                        okButtonProps: { style: { display: "inline-block" } },
                        cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
                        onOk() {
                          getTillData();
                        },
                      });
                    }
                  }
                } catch (error) {
                  setTillValue({});
                  console.error("An error occurred:", error);
                  message.error(error);
                  setLoading(false);
                }
              };
              handleStoreOps();
            }
          } else {
            setTillValue({});
            setLoading(false);
            errorMessage("Login Failed", "User not configured for this Till", "user");
          }
        } else {
          setLoading(false);
        }
      } else {
        getTillData();
      }
    }
  }, [runEffect]);

  const getTillData = async () => {
    if (authHeaders && cleanToken && (username || email)) {
      setLoading(true);
      try {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const userid = userData?.user_id;
        const response = await getTills(userid);
        const tillsData = response?.data?.data?.getTills ?? [];
        const transformedData = tillsData.reduce((result, item) => {
          const { name } = item;
          const existingGroupIndex = result.findIndex((group) => group[name]);
          if (existingGroupIndex === -1) {
            result.push({ [name]: [item] });
          } else {
            result[existingGroupIndex][name].push(item);
          }
          return result;
        }, []);
        setTills(transformedData);
      } catch (error) {
        if (!error.response) {
          console.error("Network error: Unable to connect to the server", error);
          message.error(`${messages.errors.network.connection_failed}`);
        } else {
          console.error("Error while fetching till data:", error);
          message.error(`${messages.errors.till_management.fetch_error}`);
        }
      } finally {
        setLoading(false);
      }
    }
  };

  const callTillRegistration = async (cwrTillID, search_key) => {
    try {
      const syncId = uuidv4().replace(/-/g, "").toUpperCase();
      const timeMark = timeStamp();
      const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
      const tillData = resData?.data?.data?.tillRegistration;
      if (tillData?.status === "200" && tillData.tillAccess?.length > 0) {
        localStorage.setItem("syncId", syncId);
        localStorage.setItem("documentSequence", tillData.tillAccess[0].cwrTill?.nextAssignedNumber);
        await db.tillRegistrations.add(tillData);
        const activityResponse = await upsertPOSActivity(tillData);
        if (activityResponse?.data?.data?.upsertPOSActivity?.status === "200") {
          setTillValue({});
          history.push(`/login`);
        }
      } else {
        setTillValue({});
        throw new Error(tillData?.message || "Till registration failed.");
      }
    } catch (error) {
      setTillValue({});
      console.error("An error occurred:", error);
      setLoading(false);
      errorMessage(error.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  const onRegistration = async (search_key, csbUnitId, csUserId, cwrTillID) => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userid = userData?.user_id;
    let posConfig = {};
    if (username || email) {
      try {
        setLoading(true);
        const userData = Enterprise ? username : email;
        await syncTillData(userData, authHeaders);
        let tillData = JSON.parse(localStorage.getItem("tillData"));
        localStorage.setItem("tillData", JSON.stringify(tillData));
        const posConfigResponse = await posConfigService(cwrTillID);
        if (posConfigResponse?.data?.data?.getPOSConfig?.length > 0) {
          posConfig = posConfigResponse.data.data.getPOSConfig[0];
          const posConfigData = JSON.parse(posConfig?.configJson || "{}");
          const feedbackData = JSON.parse(posConfig?.feedback || "{}");
          const registrationTypes = JSON.parse(posConfig?.registrationTypes || "[]");
          localStorage.setItem("registrationTypes", JSON.stringify(registrationTypes));
          localStorage.setItem("posConfig", JSON.stringify(posConfigData));
          localStorage.setItem("posConfigData", JSON.stringify(posConfig));
          localStorage.setItem("feedbackJson", JSON.stringify(feedbackData));
        } else {
          errorMessage("Login Failed", "Error in getting POS configuration");
        }
        let matchedRep;
        if (tillData !== null && tillData !== undefined) {
          const tillAccessData = tillData.tillAccess;
          if (!tillAccessData || !Array.isArray(tillAccessData) || tillAccessData?.length === 0) return;
          const nameTill = JSON.parse(localStorage.getItem("tillValue"))?.name;
          const tillAccessIndex = (tillAccessData || [])?.findIndex((accessTill) => accessTill.cwrTill.till === nameTill);
          if (tillAccessIndex >= 0 || (tillAccessData && typeof tillAccessData === "object" && !Array.isArray(tillAccessData))) {
            tillData.tillAccess = tillAccessIndex >= 0 ? tillAccessData[tillAccessIndex] : tillAccessData;
            const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
            console.log("username ==============>", username);
            matchedRep = salesReps.find((rep) => rep.name === username);
          }
        }
        if (posConfig?.posType === "PRD") {
          history.push("/login");
        } else if (matchedRep) {
          history.push("/login");
        } else {
          const result = await handleStoreOpsService(csbUnitId);
          if (result?.redirected) return;
          if (result?.data?.data?.getStoreOps?.status === "ERR") {
            setLoading(false);
            const remarks = result?.data?.data?.getStoreOps?.remarks;
            const products = parseRemarksProducts(remarks);
            if (products.length > 0) {
              setErrorProducts(products);
              setErrorModalVisible(true);
            } else {
              message.error(remarks || `${messages.errors.system.unexpected_error}`);
            }
            return;
          } else if (result?.data?.data?.getStoreOps?.status === "WAR") {
            message.error(result?.data?.data?.getStoreOps?.remarks);
          }
          if (result?.data?.data?.getStoreOps === null) {
            const resStoreOps = await upsertStoreOps(csbUnitId, userid);
            if (resStoreOps?.data?.data?.upsertStoreOps?.status === "200") {
              let syncId = uuidv4().replace(/-/g, "").toUpperCase();
              const timeMark = timeStamp();
              const resData = await tillRegistration(syncId, cwrTillID, search_key, timeMark, username);
              const tillData = resData.data.data.tillRegistration;
              localStorage.setItem("syncId", syncId);
              if (tillData?.status === "200") {
                await db.tillRegistrations.add(tillData);
                localStorage.setItem("documentSequence", tillData.tillAccess[0].cwrTill.nextAssignedNumber);
                setLoading(false);
                const response = await upsertPOSActivity(tillData);
                if (response?.data?.data?.upsertPOSActivity?.status === 200 || response?.data?.data?.upsertPOSActivity?.status === "200") {
                  history.push(`/login`);
                }
              } else {
                setLoading(false);
                errorMessage(tillData.message);
              }
            } else {
              message.error(resStoreOps?.data?.data?.upsertStoreOps?.message);
              setTillValue({});
              setTimeout(() => {
                for (let key in localStorage) {
                  if (key !== "userData") {
                    localStorage.removeItem(key);
                  }
                }
                window.location.assign("/");
              }, 3000);
            }
          } else if (result?.data?.data?.getStoreOps?.status === "OP") {
            await callTillRegistration(cwrTillID, search_key);
          } else {
            setLoading(false);
            Modal.confirm({
              title: `This till has been closed "${moment(new Date()).format("YYYY-MM-DD HH:mm:ss")}"`,
              icon: null,
              cancelText: "",
              okText: "Okay",
              okButtonProps: { style: { display: "inline-block" } },
              cancelButtonProps: { style: { display: "none" } }, // Disable the cancel button
              onOk() {
                Modal.destroyAll();
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        errorMessage("Error", "An error occurred while fetching till data");
      }
    }
  };

  const onModalOkay = () => {
    setLoading(false);
    const keepKey = "userData"; // Replace with the key you want to keep
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key !== keepKey) {
        localStorage.removeItem(key);
      }
    }
  };

  const onUserModal = () => {
    const cookiesToDelete = document.cookie.split(";").map((cookie) => cookie.trim());
    const domainURL = process.env.REACT_APP_domain;
    for (let i = 0; i < cookiesToDelete.length; i++) {
      const cookie = cookiesToDelete[i];
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      const domain = "domain=" + domainURL;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; secure=true; SameSite=Strict;" + domain;
    }
    localStorage.removeItem("tillSession");
    window.location.assign(`${redirectUrl}sign-in`);
  };

  const errorMessage = (modalTitle, modalContent, user) => {
    Modal.error({
      title: modalTitle,
      content: modalContent,
      onOk: user ? onUserModal : onModalOkay,
    });
  };

  const onTill = () => {
    if (cleanToken !== "bearer undefined" && (email || username)) {
      setRunEffect(true);
    } else {
      history.push("/sign-in");
    }
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 36 }} className="spinLoader" spin />} spinning={loading}>
      {authHeaders ? (
        <Row>
          <Col style={{ backgroundColor: "#F5FAFF" }} span={8}>
            <div style={{ height: "100vh" }}>
              <Image preview={false} src={logo} style={{ paddingTop: "4.5vh", paddingLeft: "2.6em", width: "93%" }} />
              <p style={{ fontFamily: "Inter", fontWeight: 600, fontSize: "1.8vw", paddingTop: "7vh", paddingLeft: "3em", color: "#0F0718" }}>
                Welcome to Point of Sale
                {multilingual && <span style={{ display: "block" }}>{t("Welcome to Point of Sale")}</span>}
              </p>
              <Image preview={false} src={laptop3} style={{ width: "30vw", marginLeft: "2em", height: "43vh" }} />
              <p style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "13px", paddingTop: "7vh", paddingLeft: "3em" }}>Point of Sale </p>
              <p style={{ fontFamily: "Inter", fontWeight: 600, color: "#667085", fontSize: "0.9vw", paddingTop: "0.5em", paddingLeft: "3em", paddingRight: "5em" }}>
                {" "}
                Centralize the operations of your store, process transactions, manage inventory, follow orders, create reports of the store’s activities and much more!
              </p>
            </div>
          </Col>
          <Col span={16}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "1.5rem 2rem" }}>
              <p
                style={{
                  fontFamily: "Inter, sans-serif",
                  fontWeight: 600,
                  fontSize: "1.25rem", // 20px
                  color: "#0F0718",
                  margin: 0,
                }}
              >
                {getMultilingualText("Select a Till to login")}
              </p>
              <div
                onClick={() => window.location.reload()}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                }}
              >
                <img src={SyncSide} alt="Refresh" style={{ height: "20px", width: "20px" }} />
                <span
                  style={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 500,
                    fontSize: "1rem", // 16px
                    color: "#0F0718",
                    marginLeft: "0.5rem",
                  }}
                >
                  Refresh
                </span>
              </div>
            </div>
            <Scrollbars style={{ height: "85vh" }}>
              {authHeaders?.access_token &&
                (authHeaders?.username || authHeaders?.email) &&
                tills?.map((e, index) => (
                  <div key={index} style={{ marginLeft: "2em", marginBottom: "1.5em" }}>
                    <p
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: "1vw",
                        paddingTop: "1.5em",
                        paddingLeft: "0.2em",
                        color: "#585768",
                        marginBottom: "0.5em",
                      }}
                    >
                      {Object.keys(e)[0]}
                    </p>

                    {/* 🔄 Responsive Flex Container */}
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "0.8rem",
                      }}
                    >
                      {e[Object.keys(e)[0]].map((res) => (
                        <Card
                          key={res.cwrTillID}
                          id="step1"
                          bodyStyle={{ padding: "1vw", paddingBottom: 0 }}
                          style={{
                            flex: "1 1 calc(20% - 1.5rem)",
                            minWidth: "10.5em",
                            maxWidth: "11em",
                            height: "8em",
                            borderRadius: "6px",
                            border: "1px solid #EEEEEF",
                            boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                            backgroundColor: "#F3F4F9",
                            cursor: "pointer",
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                          }}
                          onClick={() => {
                            localStorage.setItem(
                              "tillValue",
                              JSON.stringify({
                                search_key: res.searchKey,
                                cwr_till_id: res.cwrTillID,
                                name: res.till,
                                cSBunitID: res.cSBunitID,
                              })
                            );
                            onRegistration(res.searchKey, res.cSBunitID, res.cSUserId, res.cwrTillID);
                          }}
                        >
                          <div style={{ flexGrow: 1 }}>
                            <div>
                              <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                              <span style={{ marginLeft: "1em", color: "#0F0718" }}>{res.till}</span>
                            </div>
                          </div>

                          <div style={{ position: "absolute", bottom: 0, left: "1vw" }}>
                            <Image preview={false} src={res.status === "AVL" ? green : res.status === "INU" ? red : green} style={{ height: "0.9vw" }} />
                            <span
                              style={{
                                marginLeft: "5px",
                                fontSize: "1vw",
                                fontWeight: 600,
                                color: "#0F0718",
                              }}
                            >
                              {res.status === "AVL" ? "Available" : res.status === "INU" ? "In Use" : "Not Registered"}
                            </span>
                            <p
                              style={{
                                fontFamily: "Inter",
                                fontWeight: 600,
                                color: "#667085",
                                fontSize: "0.9vw",
                                marginBottom: "7px",
                              }}
                            >
                              {/* {res.userName} */}
                            </p>
                          </div>
                        </Card>
                      ))}
                    </div>
                  </div>
                ))}

              {/* ✅ Active Till (Same Responsive Layout) */}
              {!tills && tillValue?.search_key && (
                <div style={{ marginLeft: "2em", marginBottom: "2em" }}>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.5rem",
                    }}
                  >
                    <Card
                      id="step1"
                      key={tillValue?.cwrTillID}
                      bodyStyle={{ padding: "1vw" }}
                      style={{
                        height: "7.5em",
                        width: "11em",
                        borderRadius: "6px",
                        border: "1px solid #EEEEEF",
                        boxShadow: "0px 0px 10px 1px rgba(0, 0, 0, 0.04)",
                        backgroundColor: "#F3F4F9",
                        cursor: "pointer",
                      }}
                      onClick={onTill}
                    >
                      <div>
                        <Image preview={false} src={posImg} style={{ height: "1.5vw" }} />
                        <span style={{ marginLeft: "1em", top: "15px" }}>{tillValue?.name}</span>
                      </div>
                      <div style={{ paddingTop: "1em" }}>
                        <span style={{ marginLeft: "5px", fontSize: "1vw", fontWeight: 600 }}></span>
                      </div>
                      <p
                        style={{
                          fontFamily: "Inter",
                          fontWeight: 600,
                          marginLeft: "1.3em",
                          color: "#667085",
                          fontSize: "0.9vw",
                        }}
                      >
                        {tillValue?.userName}
                      </p>
                    </Card>
                  </div>
                </div>
              )}
            </Scrollbars>
          </Col>
          <Modal
            title="Stock Count Check Failed"
            visible={errorModalVisible}
            onOk={() => setErrorModalVisible(false)}
            footer={[
              <Button key="ok" type="primary" onClick={() => setErrorModalVisible(false)}>
                OK
              </Button>,
            ]}
            onCancel={() => setErrorModalVisible(false)}
            centered
            width="70%"
          >
            <Table
              columns={[
                { title: "Item Name", dataIndex: "item_name", key: "item_name" },
                { title: "Item Code", dataIndex: "item_code", key: "item_code" },
              ]}
              dataSource={errorProducts}
              rowKey="item_code"
              pagination={false}
              size="small"
              scroll={{ x: "100%", y: "calc(100vh - 300px)" }}
            />
          </Modal>
        </Row>
      ) : (
        <Row></Row>
      )}
      <PostCloseSalesModal
        visible={postCloseModalVisible}
        storeClosedDate={postCloseData.storeClosedDate}
        newBusinessDate={postCloseData.newBusinessDate}
        closedTime={postCloseData.closedTime}
        tillId={postCloseData.tillId}
        cashierName={postCloseData.cashierName}
        onContinue={handlePostCloseContinue}
        onCancel={handlePostCloseCancel}
      />
    </Spin>
  );
};
export default Till;
